import React, { useState } from "react";
import {
    Box,
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Grid,
    TextField,
    Typography,
    Button,
    Checkbox, Divider,
    Radio,
    FormControlLabel,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useLocation } from 'react-router-dom';
import { updateUpdateAdOption } from "../../../context/createAPI";
import { useData } from "../../../context/DataContext";
import CustomButton from "../../../components/buttons/customButton";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import { getClientTheme } from "../../../theme/clientTheme";

function AdOptionEdit() {
    const navigate = useNavigate();
    const location = useLocation();
    const { rowData } = location.state || {};
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const { user = {}, handleAdOption, user_client_id } = useData();
    const clientTheme = getClientTheme(user_client_id);
    const [data, setData] = useState(() => {
        const r = rowData?.adoption_report;
        try {
            const arr = Array.isArray(r) ? r : JSON.parse(r);
            return arr?.[0] || {};
        } catch {
            return {};
        }
    });


    const [loader, setLoader] = useState(false);

    const options = [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 }
    ];

    const handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        const newValue = type === "checkbox" ? (checked ? 1 : 0) : parseInt(value, 10)
        setData(prevData => ({
            ...prevData,
            [name]: {
                value: newValue,
                type: type
            }
        }));
    };

    const formFields = [
        { value: 1, label: rowData?.village_name, labelName: "Village Name" },
        { value: 2, label: rowData?.farmer_name, labelName: "Farmer Name" },
        { value: 3, label: rowData?.year, labelName: "Year" },
        { value: 4, label: rowData?.group_name, labelName: "Group Name" },
    ].filter(field => field.label != null);

    const [searchQuery, setSearchQuery] = useState("");


    const filteredDataKeys = Object.entries(data).filter(([key]) =>
        key.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const handleSubmit = async () => {
        setLoader(true);
        try {
            const params = {
                id: rowData?.id,
                adoption_report: [data],
                updated_by: user.user_id
            };

            const createSession = await updateUpdateAdOption(params);
            if (createSession.statusCode === 200) {
                handleAdOption();
                setTimeout(() => {
                    navigate('/adOption/history');
                }, 1000);

                setSnackbar({
                    open: true,
                    message: createSession.data || "Updating Successfully",
                    severity: "success",
                });
            }
        } catch (error) {
            console.error(error);
            setSnackbar({
                open: true,
                message: error,
                severity: "success",
            });
        }
    }

    return (
        <Box>

            <Card elevation={6}>
                <Box mt={1} textAlign="left" p={1}>
                    <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <CustomButton
                            label="Back"
                            status={false}
                            onClick={() => navigate(-1)}
                            icon={<ArrowBackIcon />}
                        />
                    </Box>
                </Box>


                <Divider sx={{ my: 0, bgcolor: '#f5f1f1ff' }} />

                {/* Header */}
                <CardHeader
                    title={
                        <Grid container spacing={2}>
                            {formFields.map((item) => (
                                <Grid item size={{ xs: 12, md: 4 }} key={item.value}>
                                    <Typography
                                        variant="subtitle2"
                                        fontWeight="bold"
                                        textTransform="uppercase"
                                    >
                                        {item.labelName}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={item.label}
                                        disabled
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                color: "#000",        // value text color
                                            },
                                            "& .Mui-disabled .MuiInputBase-input": {
                                                WebkitTextFillColor: "#000",   // important for disabled
                                            },
                                            // background for disabled
                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                backgroundColor: "#e5e5e5",      // change to what you want
                                            },
                                            "& .MuiInputLabel-root": {
                                                color: "#000",
                                                fontWeight: 700, // thick black
                                            },
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    }
                />

                {/* Body */}
                <CardContent className="adOptionScrolling">
                    {/* Search */}
                    <Grid container spacing={2} mb={3} sx={{
                        display: "flex", justifyContent: "flex-end", p: 1,
                        backgroundColor: clientTheme.activeBg,
                    }}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <TextField
                                fullWidth
                                size="small"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                sx={{
                                    mb: 0,
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "green",
                                        color: "#fff",

                                        "& fieldset": {
                                            borderColor: "transparent",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "transparent",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "transparent",
                                        },
                                    },

                                    "& .MuiInputBase-input::placeholder": {
                                        color: "#fff",
                                        opacity: 0.9,
                                    },
                                }}
                            />
                        </Grid>
                    </Grid>

                    {/* Options */}
                    <Grid container spacing={3}>
                        {
                            filteredDataKeys.length === 0 ? <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "100%",        // or give fixed height like 200px if needed
                                    width: "100%",
                                    textAlign: "center",
                                }}
                            >
                                <Typography mt={2} mb={2}>No Data Found</Typography>
                            </Box>
                                :

                                filteredDataKeys.map(([key, { value, type }]) => (
                                    <Grid item size={{ xs: 12, md: 4 }} key={key}>
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight="bold"
                                            textTransform="uppercase"
                                            gutterBottom
                                        >
                                            {key.replace(/([A-Z])/g, " $1")}
                                        </Typography>

                                        <Box
                                            display="flex"
                                            justifyContent={type === "checkbox" ? "center" : "flex-start"}
                                            flexWrap="wrap"
                                        >
                                            {options
                                                .filter(
                                                    (option) =>
                                                        !(type === "checkbox" && option.value === 0)
                                                )
                                                .map((option) => (
                                                    <FormControlLabel
                                                        key={option.value}
                                                        control={
                                                            type === "checkbox" ? (
                                                                <Checkbox
                                                                    checked={value === option.value}
                                                                    onChange={handleChange}
                                                                    name={key}
                                                                    value={option.value}
                                                                    color="success"
                                                                />
                                                            ) : (
                                                                <Radio
                                                                    checked={value === option.value}
                                                                    onChange={handleChange}
                                                                    name={key}
                                                                    value={option.value}
                                                                    color="success"
                                                                />
                                                            )
                                                        }
                                                        label={type === "checkbox" ? "" : option.label}
                                                    />
                                                ))}
                                        </Box>
                                    </Grid>
                                ))}
                    </Grid>
                </CardContent>

                {/* Footer */}
                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={loader === true ? "loading" : "idle"}
                        onClick={handleSubmit}
                        label="Update"
                        loadingLabel="Updating.."
                    />
                </CardActions>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    );
}
export default AdOptionEdit;